import CustomSelect from "./dropdown"

window.CustomSelect = CustomSelect;